import { EpaGridOrderByFetchParams } from "../../leap-components/Grid/EpaGridProps";
import { API_URL } from "./../Config";
import { FetchResponse } from "../FetchResponse";
import { PageResult } from "../Pagination";

export interface IAbstraction {
  licenceid: string;
  registernumber: string;
  sitecomputedaddress: string;
  organisationname: string;
  abstractionpurpose: string;
  otherabstractionpurpose: string;
  otherlegislation: string;
  restrictionsexist: boolean;
  restrictionsdetails: string;
  impoundmenttype: string;
  maximumdailyvolume: number;
  licencestatus: string;
  licencesubstatus: string;
  county: string;
  openforsubmissions: number;
  openforsubmissionstext: string;
  abstractionname: string;
  licenceprofileid: string;
  numberofabspoints: number;
  applicationreceiveddate: string;
  licenceissueddate: string;
}

export interface IAbstractionDetails {
  licenceid: string;
  registernumber: string;
  sitecomputedaddress: string;
  organisationname: string;
  licencestatus: string;
  county: string;
  openforsubmissions: number;
  openforsubmissionstext: string;
  abstractionpurpose: string;
  maximumdailyvolume: number;
  applicationreceiveddate: string;
  licenceissueddate: string;
}

export interface IAbstractionResponse {
  response: FetchResponse;
  abstraction?: IAbstractionDetails;
}

export async function GetAbstractionByRegnoFetchUrl(
  reg_no: string
): Promise<IAbstractionResponse> {
  var url = `${API_URL}/Licence/absbyregno?reg_no=${reg_no}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/abs-licence-details`;
  }

  var response = await fetch(url);

  if (!response.ok) {
    return {
      response: {
        ok: false,
        httpStatusCode: response.status,
        httpErr: response.statusText,
      },
    };
  }

  var body = <IAbstractionDetails>await response.json();

  const abstraction = <IAbstractionDetails>{
    licenceid: body.licenceid,
    registernumber: body.registernumber,
    sitecomputedaddress: body.sitecomputedaddress,
    organisationname: body.organisationname,
    abstractionpurpose: body.abstractionpurpose,
    maximumdailyvolume: body.maximumdailyvolume,
    licencestatus: body.licencestatus,
    county: body.county,
    openforsubmissions: body.openforsubmissions,
    openforsubmissionstext: body.openforsubmissionstext,
    applicationreceiveddate: body.applicationreceiveddate,
    licenceissueddate: body.licenceissueddate,
  };

  return <IAbstractionResponse>{
    response: {},
    abstraction: abstraction,
  };
}

export const GetAbstractionsFetchUrl = (
  pageNo: number,
  recordsPerPage: number,
  filters: any
) => {
  let params = `?page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/Licence/abslicenceslist${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/abs-licences`;
  }

  return url;
};

export const GetFilteredAbstractionsFetchUrl = (
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any,
  orderBy?: EpaGridOrderByFetchParams
) => {
  let params = `?page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;

      if (f.value != "All") params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  if (orderBy) {
    let orderByParam = "";
    switch (orderBy?.orderByName) {
      case "Open For Submissions":
        orderByParam = "openforsubmissions";
        break;

      case "Register Number":
      default:
        orderByParam = "registernumber";
    }

    params += `&order_by=${encodeURIComponent(orderByParam)}${
      orderBy.orderByAscending ? "" : "[desc]"
    }`;
  }

  let url = `${API_URL}/Licence/abslicenceslist${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/abs-licences`;
  }

  return url;
};

export const GetFilteredAbstractionsCsv = (
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any,
  orderBy?: EpaGridOrderByFetchParams
) => {
  let params = `?page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  if (orderBy) {
    let orderByParam = "";
    switch (orderBy?.orderByName) {
      case "Open For Submissions":
        orderByParam = "openforsubmissions";
        break;

      case "Register Number":
      default:
        orderByParam = "registernumber";
    }

    params += `&order_by=${encodeURIComponent(orderByParam)}${
      orderBy.orderByAscending ? "" : "[desc]"
    }`;
  }

  let url = `${API_URL}/Licence/abslicenceslistcsv${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/abs-licences`;
  }

  return url;
};

export const GetFilteredDocumentsFetchUrl = (
  AbstractionId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `?licence_id=${AbstractionId}&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Document/listbylicenceid${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents`;
  }

  return url;
};

export const GetFilteredDocumentsFilteredFetchUrl = (
  AbstractionId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `?licence_id=${AbstractionId}&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/Document/listbylicenceidfullfiltered${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/documents`;
  }

  return url;
};

export const GetAbstractionPointsCsvUrl = () => {
  let params = `?page=1&per_page=10000`;

  let url = `${API_URL}/Licence/abspointslistcsv${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/abs-licences`;
  }

  return url;
};
